<template>
  <!-- Khung chuẩn của trang admin gốc: main.app-content > .app-title > .row > .col-12 > .tile.
       Thiếu khung này thì nội dung tràn ra ngoài vùng nội dung, sidebar đè lên. -->
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1><font-awesome-icon icon="envelope-open-text"/> {{ $t('pageTitle') }}</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
        <!-- Hai loại nằm ở hai collection phân trang riêng nên không gộp chung một trang
             được; chip đổi nguồn, mỗi lúc vẫn gọi đúng một endpoint. -->
        <div class="c-type-chips mb-3">
          <button v-for="l in loaiOptions" :key="l.value" type="button" class="c-type-chip"
                  :class="{active: loai === l.value}" @click="doiLoai(l.value)">
            {{ l.text }}
            <span v-if="dem[l.value] != null" class="c-type-chip__count">{{ dem[l.value] }}</span>
          </button>
        </div>

        <div class="row mb-3">
          <div class="col-lg-8">
            <b-form-group class="mb-0">
              <b-form-radio-group v-model="filterFormModel.status" buttons button-variant="outline-primary" size="sm"
                                  :options="statusOptions" @change="reload"></b-form-radio-group>
            </b-form-group>
          </div>
          <div class="col-lg-4 text-right">
            <b-input-group size="sm">
              <b-form-input v-model="filterFormModel.keyword" :placeholder="$t('searchByName')"
                            @keyup.enter="reload"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" @click="reload"><font-awesome-icon icon="search"/></b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
        </div>

        <div v-if="loading" class="text-center text-primary py-4"><b-spinner></b-spinner></div>

        <div v-else-if="!items.length" class="text-center text-muted py-4">{{ $t('queueEmpty') }}</div>

        <div v-else class="table-responsive">
          <table class="table table-bordered">
            <thead>
            <tr>
              <th style="width: 180px;">{{ $t('client') }}</th>
              <th>{{ $t('request') }}</th>
              <th style="width: 150px;">{{ $t('status') }}</th>
              <th style="width: 130px;">{{ $t('waitingFrom') }}</th>
              <th style="width: 280px;">{{ $t('action') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in items" :key="item._id">
              <td>
                <!-- Mẫu cũ có thể mất khách (đã xoá): ô trống trơn khiến người trực tưởng lỗi. -->
                <b v-if="item.client">{{ item.client.companyName }}</b>
                <span v-else class="text-muted">&mdash;</span>
                <div class="small text-muted" v-if="item.client">{{ item.client.domain }}</div>
                <div class="small text-muted" v-if="!laSms && item.oa">{{ item.oa.name }}</div>
                <div class="small text-muted" v-if="laSms && item.brandName">{{ item.brandName.name }}</div>
              </td>
              <td>
                <b>{{ item.name }}</b>
                <div class="small">
                  <span class="badge badge-primary">{{ loaiNhan(item) }}</span>
                  <span class="text-muted ml-1">{{ item.title }}</span>
                </div>
                <div class="small text-muted" v-if="laSms">{{ item.content }}</div>
                <div class="small text-muted" v-if="laSms">{{ dongPhi(item) }}</div>
                <div class="small text-muted" v-else-if="item.trigger">{{ $t('trigger') }}: {{ item.trigger }}</div>
              </td>
              <td>
                <span class="badge" :class="'badge-' + statusOf(item).variant">{{ statusOf(item).text }}</span>
                <div class="small text-danger mt-1" v-if="item.rejectReason">{{ item.rejectReason }}</div>
                <div class="small text-muted mt-1" v-if="item.providerRef">{{ $t('providerRef') }}: {{ item.providerRef }}</div>
                <div class="small text-muted mt-1" v-if="laSms && item.ref">{{ $t('carrierRef') }}: {{ item.ref }}</div>
              </td>
              <td>
                <div>{{ mocCho(item) | moment('DD/MM/YYYY HH:mm') }}</div>
                <div class="small" :class="quaHan(item) ? 'text-danger font-weight-bold' : 'text-muted'">
                  {{ mocCho(item) | moment('from') }}
                </div>
              </td>
              <td>
                <div class="mb-2">
                  <b-button size="sm" variant="outline-secondary" class="mr-1" @click="xemChiTiet(item)">
                    <font-awesome-icon icon="eye"/> {{ $t('viewDetail') }}
                  </b-button>
                  <b-button v-if="coTheXoa" size="sm" variant="outline-danger" @click="xoa(item)">
                    <font-awesome-icon icon="trash"/>
                  </b-button>
                </div>

                <!-- Mẫu SMS do nhà mạng duyệt thẳng: chỉ hai nút. -->
                <template v-if="laSms">
                  <template v-if="!item.approveTime && !item.denyTime">
                    <b-button size="sm" variant="success" class="mr-1" @click="duyetSms(item)">{{ $t('approve') }}</b-button>
                    <b-button size="sm" variant="outline-danger" @click="tuChoiSms(item)">{{ $t('deny') }}</b-button>
                  </template>
                  <span v-else class="text-muted small">{{ $t('noActionLeft') }}</span>
                </template>

                <!-- Mẫu ZBS phải qua đối tác: rà xong thì tải file rồi mới đánh dấu đã nộp.
                     Đối tác chỉ nhận file nên bước tải là bắt buộc, không phải tiện ích. -->
                <template v-else-if="!item.forwardTime">
                  <div class="alert alert-info py-2 px-2 mb-2 small">
                    <div class="font-weight-bold mb-1">{{ $t('twoSteps') }}</div>
                    <b-button size="sm" variant="primary" class="mr-1 mb-1" @click="taiFile(item)">
                      <font-awesome-icon icon="file-excel"/> {{ $t('downloadFile') }}
                    </b-button>
                    <b-button size="sm" variant="info" class="mb-1" @click="danhDauDaNop(item)">
                      {{ $t('markForwarded') }}
                    </b-button>
                  </div>
                  <b-button size="sm" variant="outline-danger" @click="traVe(item, 'internal')">{{ $t('returnToClient') }}</b-button>
                </template>
                <template v-else>
                  <b-button size="sm" variant="success" class="mr-1 mb-1" @click="zaloDuyet(item)">
                    {{ $t('zaloApproved') }}
                  </b-button>
                  <b-button size="sm" variant="outline-danger" class="mb-1" @click="traVe(item, 'external')">
                    {{ $t('zaloRejected') }}
                  </b-button>
                  <div>
                    <b-button size="sm" variant="outline-secondary" @click="taiFile(item)">
                      <font-awesome-icon icon="file-excel"/> {{ $t('downloadFile') }}
                    </b-button>
                  </div>
                </template>
              </td>
            </tr>
            </tbody>
          </table>

          <b-modal v-model="hienChiTiet" :title="$t('viewDetail')" size="lg" hide-footer>
            <template v-if="chiTiet">
              <div class="mb-3">
                <b>{{ chiTiet.name }}</b>
                <span class="badge badge-primary ml-1">{{ loaiNhan(chiTiet) }}</span>
                <span class="badge ml-1" :class="'badge-' + statusOf(chiTiet).variant">{{ statusOf(chiTiet).text }}</span>
                <div class="small text-muted" v-if="chiTiet.client">
                  {{ chiTiet.client.companyName }} &middot; {{ chiTiet.client.domain }}
                </div>
              </div>

              <table class="table table-sm table-bordered mb-0">
                <tr v-for="d in dongChiTiet" :key="d.nhan">
                  <th style="width: 190px;">{{ d.nhan }}</th>
                  <td style="white-space: pre-line; word-break: break-word;">{{ d.giaTri }}</td>
                </tr>
              </table>
            </template>
          </b-modal>

          <b-pagination v-if="itemCount > filterFormModel.pageSize" size="sm" class="justify-content-center"
                        v-model="filterFormModel.page" :total-rows="itemCount"
                        :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
        </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
// Một hàng đợi cho cả mẫu SMS và mẫu ZBS. Mỗi nút ở cột Thao tác đổi đúng một bước mà
// khách đang nhìn thấy bên màn của họ.
const NGUON = {
  zbs: {service: '/zns-template/register/queue', macDinh: 'submitted'},
  sms: {service: '/sms-template', macDinh: 'waiting'},
};

export default {
  name: 'MessageRegisterQueue',
  data() {
    return {
      loai: 'zbs',
      hienChiTiet: false,
      chiTiet: null,
      items: [],
      itemCount: 0,
      dem: {},
      loading: false,
      filterFormModel: {status: 'submitted', keyword: '', page: 1, pageSize: 50},
    }
  },
  computed: {
    laSms() {
      return this.loai === 'sms';
    },
    loaiOptions() {
      return [
        {value: 'zbs', text: this.$t('typeZbs')},
        {value: 'sms', text: this.$t('typeSms')},
      ];
    },
    statusOptions() {
      // "Tất cả" gộp được vì đây là lọc trạng thái trong CÙNG một collection — khác chip
      // loại ở trên (hai collection phân trang riêng, không gộp được).
      const tatCa = {value: '', text: this.$t('statusAll')};
      // Mẫu SMS do nhà mạng duyệt thẳng nên không có bước nộp đối tác.
      if (this.laSms) {
        return [
          tatCa,
          {value: 'waiting', text: this.$t('statusWaitingCarrier')},
          {value: 'approved', text: this.$t('statusApproved')},
          {value: 'denied', text: this.$t('statusRejected')},
        ];
      }
      return [
        tatCa,
        {value: 'submitted', text: this.$t('statusSubmitted')},
        {value: 'forwarded', text: this.$t('statusForwarded')},
        {value: 'rejected', text: this.$t('statusRejected')},
      ];
    },
    // Gom mọi ô có nội dung thành từng dòng nhãn — giá trị, bỏ ô trống cho gọn.
    dongChiTiet() {
      const x = this.chiTiet;
      if (!x) return [];
      const d = [];
      const them = (nhan, giaTri) => { if (giaTri || giaTri === 0) d.push({nhan, giaTri: String(giaTri)}); };
      if (this.laSms) {
        them(this.$t('smsBrandNameLabel'), x.brandName && x.brandName.name);
        them(this.$t('contentLabel'), x.content);
        them(this.$t('smsCountLabel'), this.dongPhi(x));
        them(this.$t('carrierRef'), x.ref);
        (x.params || []).forEach((p, i) => them(`${this.$t('paramLabel')} ${i + 1}`, `${p.key} — ${this.$t('maxLen')} ${p.value}`));
        return d;
      }
      them('OA', x.oa && x.oa.name);
      them(this.$t('trigger'), x.trigger);
      them(this.$t('messageTagLabel'), x.tag);
      them(this.$t('titleLabel'), x.title);
      (x.paragraphs || []).forEach((p, i) => them(`${this.$t('paragraphLabel')} ${i + 1}`, p));
      (x.tableRows || []).forEach(r => them(this.$t('tableRowLabel'), `${r.label}: ${r.value}`));
      (x.subParagraphs || []).forEach((p, i) => them(`${this.$t('subParagraphLabel')} ${i + 1}`, p));
      (x.buttons || []).forEach(b => them(this.$t('buttonLabel'), `${b.title} → ${b.url || ''}`));
      const t = x.typeData || {};
      them(this.$t('bankLabel'), t.bankName);
      them(this.$t('accountLabel'), t.accountNumber && `${t.accountNumber} — ${t.accountName || ''}`);
      them(this.$t('amountLabel'), t.amount);
      them(this.$t('transferNoteLabel'), t.transferNote);
      them(this.$t('voucherTitleLabel'), t.voucherTitle);
      them(this.$t('voucherCodeLabel'), t.voucherCode);
      them(this.$t('expireLabel'), t.expireTime);
      (t.stars || []).forEach((sao, i) => {
        const phan = [sao.title, sao.subtitle, ...(sao.criteria || []), sao.thanks, sao.desc].filter(Boolean);
        if (phan.length) them(`${i + 1} ★`, phan.join('\n'));
      });
      (x.params || []).forEach(p => them(this.$t('paramLabel'), `${p.name} — ${p.value || ''}`));
      them(this.$t('noteLabel'), x.note);
      them(this.$t('providerRef'), x.providerRef);
      return d;
    },
    // Chỉ vai trò được phép mới thấy nút xoá — backend cũng chặn đúng ba vai trò này.
    coTheXoa() {
      return ['owner', 'admin', 'tech'].includes(this.$store.state.user.role);
    },
  },
  methods: {
    doiLoai(loai) {
      if (this.loai === loai) return;
      this.loai = loai;
      this.filterFormModel.status = NGUON[loai].macDinh;
      this.reload();
    },
    load() {
      this.loading = true;
      this.$service.get(NGUON[this.loai].service, {params: this.filterFormModel}).then(response => {
        this.items = response.data.docs || [];
        this.itemCount = response.data.totalDocs || 0;
        this.$set(this.dem, this.loai, this.itemCount);
      }).catch(() => {
        this.items = [];
        this.itemCount = 0;
      }).finally(() => {
        this.loading = false;
      });
    },
    reload() {
      this.filterFormModel.page = 1;
      this.load();
    },
    // Số trên chip của loại còn lại: một lượt gọi nhẹ chỉ để lấy tổng, hỏng cũng không chặn màn.
    demLoaiKia() {
      const kia = this.laSms ? 'zbs' : 'sms';
      this.$service.get(NGUON[kia].service, {params: {status: NGUON[kia].macDinh, page: 1, pageSize: 1}})
        .then(r => this.$set(this.dem, kia, r.data.totalDocs || 0))
        .catch(() => {});
    },
    // Trạng thái suy từ mốc thời gian, đúng thứ tự ngược của vòng đời.
    statusOf(item) {
      if (this.laSms) {
        if (item.approveTime) return {text: this.$t('statusApproved'), variant: 'success'};
        if (item.denyTime) return {text: this.$t('statusRejected'), variant: 'danger'};
        return {text: this.$t('statusWaitingCarrier'), variant: 'warning'};
      }
      if (item.rejectTime) {
        return item.rejectStage === 'external'
          ? {text: this.$t('statusRejectedExternal'), variant: 'danger'}
          : {text: this.$t('statusReturned'), variant: 'warning'};
      }
      if (item.forwardTime) return {text: this.$t('statusForwarded'), variant: 'info'};
      return {text: this.$t('statusSubmitted'), variant: 'warning'};
    },
    mocCho(item) {
      return this.laSms ? item.createTime : item.submitTime;
    },
    // Quá một ngày làm việc chưa tiếp nhận thì đánh dấu để CSKH thấy ngay.
    quaHan(item) {
      const moc = this.mocCho(item);
      const chuaXuLy = this.laSms ? (!item.approveTime && !item.denyTime) : !item.forwardTime;
      return chuaXuLy && moc && (Date.now() - moc) > 24 * 60 * 60 * 1000;
    },
    loaiNhan(item) {
      if (this.laSms) return 'SMS';
      const key = 'type_' + item.type;
      return this.$te(key) ? this.$t(key) : item.type;
    },
    dongPhi(item) {
      return this.$t('smsMetaLine', [item.characterCount || 0, item.numberOfSms || 0,
        item.isUnicode ? this.$t('unicode') : this.$t('nonUnicode')]);
    },
    xemChiTiet(item) {
      this.chiTiet = item;
      this.hienChiTiet = true;
    },
    // Xoá là không hoàn tác được nên nói rõ tên hồ sơ trong hộp xác nhận.
    xoa(item) {
      this.$swal({
        title: this.$t('confirmDelete'),
        text: item.name,
        icon: 'warning',
        showCancelButton: true,
      }).then(result => {
        if (!result.isConfirmed) return;
        const url = this.laSms ? `/sms-template/${item._id}` : `/zns-template/${item._id}`;
        this.$service.delete(url).then(() => this.load()).catch(error => this.baoLoi(error));
      });
    },
    taiFile(item) {
      this.$service.get(`/zns-template/register/${item._id}/excel`, {responseType: 'blob'}).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `ZBS_${item.name}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }).catch(() => {
        this.$swal({text: this.$t('downloadFailed'), icon: 'error'});
      });
    },
    danhDauDaNop(item) {
      this.$swal({
        title: this.$t('markForwarded'),
        text: this.$t('markForwardedHint'),
        input: 'text',
        inputPlaceholder: this.$t('providerRefPlaceholder'),
        showCancelButton: true,
      }).then(result => {
        if (!result.isConfirmed) return;
        this.$service.post(`/zns-template/register/${item._id}/forward`, {providerRef: result.value})
          .then(() => this.load())
          .catch(error => this.baoLoi(error));
      });
    },
    // Lý do là bắt buộc: khách đọc nguyên văn câu này nên viết cho khách hiểu.
    traVe(item, stage) {
      this.$swal({
        title: stage === 'external' ? this.$t('zaloRejected') : this.$t('returnToClient'),
        text: this.$t('rejectReasonHint'),
        input: 'textarea',
        inputValidator: value => value ? null : this.$t('rejectReasonRequired'),
        showCancelButton: true,
      }).then(result => {
        if (!result.isConfirmed) return;
        this.$service.post(`/zns-template/register/${item._id}/reject`,
          {rejectStage: stage, rejectReason: result.value})
          .then(() => this.load())
          .catch(error => this.baoLoi(error));
      });
    },
    zaloDuyet(item) {
      this.$swal({
        title: this.$t('zaloApproved'),
        text: this.$t('refIdHint'),
        input: 'text',
        inputValidator: value => value ? null : this.$t('refIdRequired'),
        showCancelButton: true,
      }).then(result => {
        if (!result.isConfirmed) return;
        this.$service.post(`/zns-template/register/${item._id}/approve`, {refId: result.value})
          .then(() => {
            this.$swal({text: this.$t('approveDone'), icon: 'success'});
            this.load();
          })
          .catch(error => this.baoLoi(error));
      });
    },
    duyetSms(item) {
      this.$swal({title: this.$t('approveConfirm'), text: this.$t('approveAlert'),
        icon: 'warning', showCancelButton: true}).then(result => {
        if (!result.isConfirmed) return;
        this.$service.put(`/sms-template/approve/${item._id}`)
          .then(() => this.load())
          .catch(error => this.baoLoi(error));
      });
    },
    tuChoiSms(item) {
      this.$swal({title: this.$t('denyConfirm'), text: this.$t('approveAlert'),
        icon: 'warning', showCancelButton: true}).then(result => {
        if (!result.isConfirmed) return;
        this.$service.put(`/sms-template/deny/${item._id}`)
          .then(() => this.load())
          .catch(error => this.baoLoi(error));
      });
    },
    baoLoi(error) {
      const data = error.response ? error.response.data : null;
      this.$swal({text: (data && data.message) || this.$t('actionFailed'), icon: 'error'});
    },
  },
  mounted() {
    this.load();
    this.demLoaiKia();
  },
  i18n: {
    messages: {
      en: {
        pageTitle: 'Message template registrations',
        statusAll: "All",
        viewDetail: "View detail",
        confirmDelete: "Delete this record?",
        smsBrandNameLabel: "Brandname",
        contentLabel: "Content",
        smsCountLabel: "Length",
        paramLabel: "Parameter",
        maxLen: "max",
        titleLabel: "Main title",
        paragraphLabel: "Paragraph",
        subParagraphLabel: "Sub-paragraph",
        tableRowLabel: "Detail row",
        buttonLabel: "Button",
        messageTagLabel: "Message tag",
        bankLabel: "Bank",
        accountLabel: "Account",
        amountLabel: "Amount",
        transferNoteLabel: "Transfer note",
        voucherTitleLabel: "Voucher title",
        voucherCodeLabel: "Voucher code",
        expireLabel: "Expires",
        noteLabel: "Note",
        typeZbs: 'ZBS templates', typeSms: 'SMS templates',
        client: 'Client', request: 'Request', status: 'Status', action: 'Action',
        waitingFrom: 'Waiting since', trigger: 'Trigger', providerRef: 'Partner ref',
        carrierRef: 'Carrier ref',
        searchByName: 'Search by template name', queueEmpty: 'Nothing in this queue',
        statusSubmitted: 'Waiting for Callio', statusForwarded: 'Filed with partner',
        statusWaitingCarrier: 'Waiting for carrier', statusApproved: 'Approved',
        statusRejected: 'Rejected', statusReturned: 'Returned to client',
        statusRejectedExternal: 'Rejected by Zalo',
        twoSteps: 'After reviewing, do these two:',
        downloadFile: 'Download file', markForwarded: 'Mark as filed',
        markForwardedHint: 'Only after you have actually sent the file to the partner.',
        providerRefPlaceholder: 'Partner reference (optional)',
        returnToClient: 'Return to client', zaloApproved: 'Zalo approved', zaloRejected: 'Zalo rejected',
        rejectReasonHint: 'The client reads this word for word. Say what needs fixing.',
        rejectReasonRequired: 'A reason is required',
        refIdHint: 'Paste the template ID Zalo issued.', refIdRequired: 'The template ID is required',
        approveDone: 'Done. The template now works for sending.',
        approve: 'Approve', deny: 'Reject', noActionLeft: 'Already decided',
        approveConfirm: 'Approve this template?', denyConfirm: 'Reject this template?',
        approveAlert: "This action can't be undone",
        actionFailed: 'Action failed', downloadFailed: 'Could not download the file',
        smsMetaLine: '{0} characters · {1} SMS · {2}', unicode: 'accented', nonUnicode: 'plain',
        type_text: 'Text', type_table: 'Table', type_rating: 'Rating',
        type_payment: 'Payment request', type_voucher: 'Voucher', type_otp: 'OTP',
      },
      vi: {
        pageTitle: 'Đăng ký mẫu tin nhắn',
        statusAll: "Tất cả",
        viewDetail: "Xem chi tiết",
        confirmDelete: "Xoá bản ghi này?",
        smsBrandNameLabel: "Brandname",
        contentLabel: "Nội dung",
        smsCountLabel: "Độ dài",
        paramLabel: "Tham số",
        maxLen: "tối đa",
        titleLabel: "Tiêu đề chính",
        paragraphLabel: "Đoạn văn",
        subParagraphLabel: "Nội dung phụ",
        tableRowLabel: "Đề mục",
        buttonLabel: "Nút bấm",
        messageTagLabel: "Loại tin",
        bankLabel: "Ngân hàng",
        accountLabel: "Tài khoản",
        amountLabel: "Số tiền",
        transferNoteLabel: "Nội dung chuyển khoản",
        voucherTitleLabel: "Tiêu đề voucher",
        voucherCodeLabel: "Mã voucher",
        expireLabel: "Hạn sử dụng",
        noteLabel: "Ghi chú",
        typeZbs: 'Mẫu ZBS', typeSms: 'Mẫu SMS',
        client: 'Khách hàng', request: 'Hồ sơ', status: 'Trạng thái', action: 'Thao tác',
        waitingFrom: 'Chờ từ', trigger: 'Điều kiện', providerRef: 'Mã đối tác',
        carrierRef: 'Mã nhà mạng',
        searchByName: 'Tìm theo tên mẫu', queueEmpty: 'Không có hồ sơ nào',
        statusSubmitted: 'Chờ Callio tiếp nhận', statusForwarded: 'Đã nộp đối tác',
        statusWaitingCarrier: 'Chờ nhà mạng duyệt', statusApproved: 'Đã duyệt',
        statusRejected: 'Bị từ chối', statusReturned: 'Đã trả về khách',
        statusRejectedExternal: 'Zalo từ chối',
        twoSteps: 'Rà xong thì làm hai việc này:',
        downloadFile: 'Tải file gửi đối tác', markForwarded: 'Đánh dấu đã nộp',
        markForwardedHint: 'Chỉ bấm sau khi đã gửi file cho đối tác thật.',
        providerRefPlaceholder: 'Mã đối tác cấp (không bắt buộc)',
        returnToClient: 'Trả về khách', zaloApproved: 'Zalo đã duyệt', zaloRejected: 'Zalo từ chối',
        rejectReasonHint: 'Khách đọc nguyên văn câu này. Viết rõ cần sửa gì.',
        rejectReasonRequired: 'Phải nhập lý do',
        refIdHint: 'Dán mã mẫu Zalo cấp.', refIdRequired: 'Phải nhập mã mẫu',
        approveDone: 'Xong. Mẫu đã dùng gửi tin được.',
        approve: 'Duyệt', deny: 'Từ chối', noActionLeft: 'Đã có phán quyết',
        approveConfirm: 'Duyệt mẫu tin này?', denyConfirm: 'Từ chối mẫu tin này?',
        approveAlert: 'Thao tác này không hoàn tác được',
        actionFailed: 'Thao tác không thành công', downloadFailed: 'Không tải được file',
        smsMetaLine: '{0} ký tự · {1} tin · {2}', unicode: 'có dấu', nonUnicode: 'không dấu',
        type_text: 'Văn bản', type_table: 'Bảng', type_rating: 'Đánh giá sao',
        type_payment: 'Yêu cầu thanh toán', type_voucher: 'Voucher', type_otp: 'OTP',
      }
    }
  },
}
</script>

<style scoped>
.c-type-chips {
  display: flex;
  gap: 6px;
}
.c-type-chip {
  border: none;
  background: #F2F2F2;
  color: #555;
  font-size: 12px;
  font-weight: 500;
  padding: 5px 13px;
  border-radius: 14px;
  cursor: pointer;
  white-space: nowrap;
}
.c-type-chip.active {
  background: #6B66C4;
  color: #fff;
  font-weight: 700;
}
.c-type-chip__count {
  margin-left: 4px;
  opacity: .7;
}
</style>
